import { createContext } from 'react';

const CardContainerContext = createContext(null);

export default CardContainerContext;
